function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m24 88h464a0 0 0 0 1 0 0v304a0 0 0 0 1 0 0h-432a32 32 0 0 1 -32-32v-272a0 0 0 0 1 0 0z",
  fill: "#2978b8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m56 120h400a0 0 0 0 1 0 0v240a0 0 0 0 1 0 0h-384a16 16 0 0 1 -16-16v-224a0 0 0 0 1 0 0z",
  fill: "#6ed2f0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m88 24v304h-32a32 32 0 0 0 -32 32v-304a32 32 0 0 1 32-32z",
  fill: "#3397e8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m456 184v-32h-80v-32h-32v96h-48v-96h-32v96h-44.8l-19.2-96h-48l9.6 48h-73.6v48h83.2l9.6 48h-92.8v32h99.2l12.8 64h48l-6.4-32h54.4v-32h-60.8l-6.4-32h115.2v96h32v-96h80v-48h-80v-32z",
  fill: "#e9eef2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m367.029 369.775h33.941v124.451h-33.941z",
  fill: "#a82a27",
  transform: "matrix(.707 -.707 .707 .707 -192.999 398.059)"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 272,
  cy: 304,
  fill: "#eb423f",
  r: 120
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 272,
  cy: 304,
  fill: "#6ed2f0",
  r: 88
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m360 304a87.6 87.6 0 0 1 -3.32 24h-44.68v54.4a88.233 88.233 0 0 1 -64 6.28v-60.68h-60.68a88.233 88.233 0 0 1 6.28-64h54.4v-44.68a88.233 88.233 0 0 1 64 6.28v38.4h38.4a87.573 87.573 0 0 1 9.6 40z",
  fill: "#e9eef2"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m488 80h-392v-56a8 8 0 0 0 -8-8h-32a40.045 40.045 0 0 0 -40 40v304a40.045 40.045 0 0 0 40 40h131.436a127.77 127.77 0 0 0 145.688 16.438l77.219 77.219a8 8 0 0 0 11.314 0l24-24a8 8 0 0 0 0-11.314l-58.343-58.343h100.686a8 8 0 0 0 8-8v-304a8 8 0 0 0 -8-8zm-92.05 192h52.05v80h-57.348a128.12 128.12 0 0 0 5.3-80zm52.05-64h-64v-16h64zm0-64h-64v-16h64zm-72 16h72v16h-72a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h72v32h-57.348a128.643 128.643 0 0 0 -38.652-51.841v-76.159h16v24a8 8 0 0 0 8 8zm-40 33.183a127.241 127.241 0 0 0 -32-13.133v-52.05h32zm-48-16.183a128.819 128.819 0 0 0 -16-1v-48h16zm-32 0a126.942 126.942 0 0 0 -34.558 9.42l-11.683-58.42h46.241zm-62.559-49 13.2 65.988a128.9 128.9 0 0 0 -27.32 21.815l-.274-1.371a8 8 0 0 0 -7.847-6.432h-75.2v-32h65.6a8 8 0 0 0 7.845-9.569l-7.686-38.431zm-48.441 160h-49v-16h52.05a127.034 127.034 0 0 0 -3.05 16zm8.35-32h-57.35v-32h68.641l1.6 7.984a127.857 127.857 0 0 0 -12.893 24.016zm-7.907-128 6.4 32h-55.843v-32zm-49.443 200v-24h48a127.3 127.3 0 0 0 9.348 48h-81.348a8.009 8.009 0 0 1 -8-8v-8h24a8 8 0 0 0 8-8zm-64-272a24.028 24.028 0 0 1 24-24h24v288h-24a39.792 39.792 0 0 0 -24 8.019zm0 304a24.039 24.039 0 0 1 16-22.624v6.624a24.028 24.028 0 0 0 24 24h89.183a128.544 128.544 0 0 0 10.976 16h-116.159a24.027 24.027 0 0 1 -24-24zm128-56a112 112 0 1 1 112 112 112.127 112.127 0 0 1 -112-112zm256 172.687-69.016-69.017a128.994 128.994 0 0 0 13.807-11.57l67.9 67.9zm64-92.687h-108.159a128.544 128.544 0 0 0 10.976-16h73.183a8 8 0 0 0 8-8v-240a8 8 0 0 0 -8-8h-360v-16h384z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m272 208a96 96 0 1 0 96 96 96.108 96.108 0 0 0 -96-96zm63.956 48h-15.956v-15.956a80.622 80.622 0 0 1 15.956 15.956zm-95.956-25.3v25.3h-31.956a80.454 80.454 0 0 1 31.956-25.3zm-41.3 105.3h41.3v41.3a80.454 80.454 0 0 1 -41.3-41.3zm57.3 46.39v-54.39a8 8 0 0 0 -8-8h-54.39a79.943 79.943 0 0 1 5.09-48h49.3a8 8 0 0 0 8-8v-38.39a79.943 79.943 0 0 1 48 5.09v33.3a8 8 0 0 0 8 8h33.3a79.943 79.943 0 0 1 5.09 48h-38.39a8 8 0 0 0 -8 8v49.3a79.943 79.943 0 0 1 -48 5.09zm64-14.434v-31.956h25.3a80.454 80.454 0 0 1 -25.3 31.956z"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 424,
  cy: 328,
  r: 8
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 424,
  cy: 296,
  r: 8
});

var SvgOtro = function SvgOtro(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Filled",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOtro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/otro.5f9cd584.svg";
export { ForwardRef as ReactComponent };